/**
 * 系统管理 用户管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-select size="small" v-model="currRole" placeholder="请选择角色" @change="getSearch">
          <el-option :label="item.role" :key="item.id" :value="item.id" v-for="item in searchRoleList"></el-option>
        </el-select>
      </el-form-item>
			<el-form-item>
				<el-cascader
					size="small"
					placeholder="请选择部门"
					v-model="formInline.depId"
					ref="depsCascader"
					:options="deptData"
					:props="{ expandTrigger: 'click',children:'deps',label:'departmentName',checkStrictly: true,value:'id'}"
					@change="getDepId"
          clearable
          filterable
          >

				 </el-cascader>
			</el-form-item>

      <el-form-item label="">
        <el-input size="small" v-model="formInline.username" placeholder="输入用户名"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.name" placeholder="用户姓名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
        <prems-button size="small" icon="el-icon-circle-plus-outline" perms="sys:user:add" label="添加" type="primary"  @click="handleEdit()" />
      </el-form-item>
    </el-form>
		<el-row>
			<el-button size="mini" type="primary" @click="disRole" style="margin-bottom: 10px;" :disabled="!currUids.length" >批量分配角色</el-button>
			<el-button size="mini" type="primary" @click="disDept" style="margin-bottom: 10px;" :disabled="!currUids.length" >批量分配部门</el-button>
		</el-row>
    <!--列表-->
    <el-table :header-cell-style="this.$store.state.headerCss" size="small" @selection-change="selectChange" :data="userData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
			<el-table-column type="selection"  width="50"></el-table-column>
			<el-table-column type="index" label="序号" width="50"></el-table-column>
      <el-table-column  prop="username" label="用户名" >
      </el-table-column>
			<el-table-column  prop="name" label="用户姓名" width="140">
			</el-table-column>
			<el-table-column  label="用户角色" width="260" show-overflow-tooltip sortable>
				<template  slot-scope="scope">
					<el-tag  size="mini" v-if="scope.row.roleVoList" :key="item.id" v-for='item in scope.row.roleVoList' class="tag">{{item.role}}</el-tag>
				</template>
			</el-table-column>
      <el-table-column   label="所属部门" show-overflow-tooltip width="200">
				<template slot-scope="scope">
					<div>{{scope.row.departmentVo.parentName}} / {{scope.row.departmentVo.departmentName}}</div>
				</template>
      </el-table-column>
      <el-table-column  prop="phone" label="手机号" width="180">
      </el-table-column>

      <el-table-column a prop="updateDate" label="修改时间" min-width="140">
        <template slot-scope="scope">
          <div>{{scope.row.updateDate|timestampToTime}}</div>
        </template>
      </el-table-column>

      <el-table-column label="操作" min-width="450">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<prems-button  perms="sys:user:deleted" label="删除"  size="mini" type="danger"  @click="deleteUser(scope.$index, scope.row)" />
					<prems-button  perms="sys:user:role" label="分配角色"  size="mini" type="primary"  @click="disRole(scope.$index, scope.row)" />
					<prems-button  perms="sys:user:dept" label="分配部门"  size="mini" type="primary"  @click="disDept(scope.$index, scope.row)" />
          <prems-button  perms="sys:user:resetpwd" label="修改密码"  size="mini" type="success"  @click="resetpwd(scope.$index, scope.row)" />
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click='closeDialog("edit")' :close-on-click-modal="false">
      <el-form label-width="80px" ref="editForm" :model="editForm" :rules="rules">

        <el-form-item label="用户名" prop="username">
          <el-input size="small" v-model="editForm.username" auto-complete="off" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input size="small" v-model="editForm.name" auto-complete="off" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item  v-if="this.title == '添加用户'" label="密码" prop="password">
         <el-input size="small" v-model="editForm.password" auto-complete="off" show-password placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input size="small" v-model="editForm.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
      <!--  <el-form-item label="房间号" prop="roomNum">
          <el-input size="small" v-model="editForm.roomNum" placeholder="请输入房间号"></el-input>
        </el-form-item> -->

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>

		<!-- 分配角色 -->
    <el-dialog :title="roleTitle" :visible.sync="roleShow" width="30%" @click='closeDialog("role")' :close-on-click-modal="false">
			<el-checkbox-group v-model="checkRoles" @change="handleCheckedRole">
				<el-checkbox v-for="role in roleList" :label="role.id" :key="role.id">{{role.role}}</el-checkbox>
			</el-checkbox-group>

			<div slot="footer" class="dialog-footer">
			  <el-button size="small" @click='closeDialog("role")'>取消</el-button>
			  <el-button size="small" type="primary" :loading="loading" class="title" @click="handleRoleSave">保存</el-button>
			</div>
    </el-dialog>
		<!-- 分配部门 -->
		<el-dialog :title="deptTitle" :visible.sync="deptShow" width="30%" @click='closeDialog("dept")' :close-on-click-modal="false">
			<el-form>
				<el-form-item label="选择部门">
				<el-cascader
					v-model="getDeptData"
					ref="depsCascader"
					:options="deptData"
					:props="{ expandTrigger: 'click',children:'deps',label:'departmentName',checkStrictly: true,value:'id'}"
					@change="handleChange">
				 </el-cascader>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
			  <el-button size="small" @click='closeDialog("dept")'>取消</el-button>
			  <el-button size="small" type="primary" :loading="loading" class="title" @click="handleDeptSave">保存</el-button>
			</div>
		</el-dialog>

    <!-- 修改密码 -->
    <el-dialog title="修改密码" :visible.sync="passwordShow" width="30%" @click='closeDialog("unit")' :close-on-click-modal="false">
      <el-form>
				<el-form-item label="输入密码">
					<el-input placeholder="输入新密码" size="medium" show-password v-model="newPassword"></el-input>
				</el-form-item>
			</el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("unit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="savePassword">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 导入请求方法
import {
  userList,
	userRoleList,
	userAdd,
	userRoleSave,
	userDelete,
	userUpdate,
	passwordUpdate,
	saveRoleIdBatch,
	deptList,
	setDept,
	setBtchDept

} from '../../api/userMG'
import Pagination from '../../components/Pagination'
import PremsButton from "@/views/permission/PreButtom";
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      title: '添加用户',
			roleTitle:'',
			isBtch:false,//是否批量
			isBtchDept:false,//是否批量分配部门
      editFormVisible: false, //控制编辑页面显示与隐藏
      roleShow: false, //控制数据权限显示与隐藏
      passwordShow: false, //控制所属单位隐藏与显示
			deptShow:false,
			deptTitle:'',
			deptId:0,
			newPassword:'',
			deptData:[],
			getDeptData:[],
      // 编辑与添加
      editForm: {
        username: '',
        name:'',
        password: '',
        phone: '',
        roomNum:''
      },
			checkRoles:[],

			//角色列表
			roleList:[],
			//搜索角色列表 ，多了一个‘所有’的选项
			searchRoleList:[],
			currRole:'',
      currUid:0,
			currUids:[],
      // 选择数据
      selectdata: [],
      // rules表单验证
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        roleId: [{ required: true, message: '请选择角色', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/,
            required: true,
            message: '请输入正确的手机号',
            trigger: 'blur'
          }
        ],

      },
      // 删除用户
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      // 重置密码
      resetpsd: {
        userId: '',
        token: localStorage.getItem('logintoken')
      },
      // 用户下线
      offline: {
        token: localStorage.getItem('logintoken')
      },
      // 请求数据参数
      formInline: {
        currentPage: 1,
        pageSize: 10,
        uid: 0,
        username: '',
				name:'',
        password: '',
        phone: '',
				roomNum:'',
				depId:'',
				roleListStr: JSON.stringify([])
      },

      //用户数据
      userData: [],
      // 数据权限
      UserDept: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination,
		PremsButton
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
		this.getUserRole()
		this.getDeptDataList();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

		getDepId:function(val){
			this.formInline.depId = val[0]
		},


    // 获取数据方法
    getdata(parameter) {
      this.loading = true

     // 获取用户列表

      userList(parameter).then(res => {
        this.loading = false

        if (res.errCode) {
          this.$message({
            type: 'info',
            message: res.msg
          })
					return
        }
				if(res.status == 1){
					this.userData = res.data.data
					// 分页赋值
					this.pageparm.currentPage = this.formInline.currentPage
					this.pageparm.pageSize = this.formInline.pageSize
					this.pageparm.total = res.data.totalCount
				}
      })
    },

		//获取角色
		getUserRole(){
			userRoleList('').then(res => {
				if(res.errCode){
					this.$message({
					  type: 'error',
					  message: res.msg
					})
					return
				}
				if(res.status == 1){
					this.roleList = res.data
					this.searchRoleList = [{id:0,role:'所有角色'},...res.data]
				}
			})
		},

		//获取部门列表
		getDeptDataList:function(){
			deptList().then(res => {
				if(res.status == 1){
					this.deptData = res.data
				}else{
					this.$message.error(res.msg)
				}
			})
		},


    // 分页插件事件
    callFather(parm) {
      this.formInline.currentPage = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    //搜索事件
    search() {
      this.getdata(this.formInline)
    },
		getSearch(val){
			if(val == 0){
				this.formInline.roleListStr = JSON.stringify([])
			}else{
				let arr = []
				let obj = {
					id:val
				}
				arr.push(obj)
				this.formInline.roleListStr = JSON.stringify(arr)
			}

		},


    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
			this.$nextTick(() => {
				this.$refs.editForm.clearValidate();
			})
      if (row != undefined && row != 'undefined') {
        this.title = '修改用户'
        this.editForm.uid = row.uid
        this.editForm.username = row.username
        this.editForm.name = row.name
				this.editForm.password = row.password
        this.editForm.phone = row.phone
        this.editForm.roomNum = row.roomNum

      } else {
        this.title = '添加用户'
        this.editForm.uid = ''
        this.editForm.username = ''
        this.editForm.name = ''
        this.editForm.password = ''
        this.editForm.phone = ''
        this.editForm.roomNum = ''
      }
    },
    // 编辑、添加提交方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
					if(this.title == '添加用户'){
						this.addUser()
					}else{
						this.updateUser()
					}
        } else {
          return false
        }
      })
    },

		updateUser(){
			userUpdate(this.editForm).then(res => {
				this.editFormVisible = false
				this.loading = false
				if(res.status == 1){
					this.$message.success('操作成功！')
					this.getdata(this.formInline)
				}
			})
			.catch(err => {
			  this.editFormVisible = false
			  this.loading = false
			  this.$message.error('操作失败，请稍后再试！')
			})
		},

		addUser(){
			  // 请求方法
			this.loading = true
			userAdd(this.editForm)
			  .then(res => {
			    this.editFormVisible = false
			    this.loading = false
			    if(res.status == 1){
						this.$message.success('用户新增成功')
						this.getdata(this.formInline)
					}else{
						this.$message.error(res.msg)
					}
			  })
			  .catch(err => {
			    this.editFormVisible = false
			    this.loading = false
			    this.$message.error('保存失败，请稍后再试！')
			  })
		},


		 //分配角色
		disRole(index, row) {

		  this.roleShow = true

			 if (row != undefined && row != 'undefined') {
				  this.isBtch = false
				  this.roleTitle = "给用户 "+row.username+" 分配角色"
					this.currUid = row.uid
					let arr = row.roleVoList.map( item => item.id)
					this.checkRoles  = arr


			 }else{
				 this.isBtch = true
				 this.roleTitle="批量分配角色"

			 }


		},
		//分配部门
		disDept(index,row){
			this.deptShow = true

		  if (row != undefined && row != 'undefined') {
				this.currUid = row.uid
				this.getDeptData = [row.departmentVo.id]
				this.isBtchDept = false
				this.deptTitle = '给用户 '+row.name +' 分配部门'
		  }else{

				console.log('sss')
				this.getDeptData = []
				this.isBtchDept = true
				this.deptTitle = '批量分配部门'
			}
		},
		handleCheckedRole(val){

			this.checkRoles = val
		},
		handleChange(val){
			this.deptId = val[val.length-1]

		},






		//分配角色--保存
		handleRoleSave(){
			if(this.isBtch){
				this.roleSaveList();
			}else{
				this.roleSave()
			}
		},

		//分配部门--保存
		handleDeptSave(){
			if(this.isBtchDept){
				this.deptSaveList()
			}else{
				this.deptSave()
			}
		},

		//分配部门
		deptSave(){
			let parameter = {
				uid:this.currUid,
				depId:this.deptId
			}
			setDept(parameter).then(res => {
				this.deptShow = false
				if(res.status == 1){

					this.$message.success('操作成功')
					this.getdata(this.formInline)
				}else{
					this.$message.error(res.msg)
				}
			})
			.catch( err => {
				this.deptShow = false
				this.$message.error('保存失败，请稍后再试！')
			})
		},





		roleSave(){
			let ids = this.checkRoles.join('-')
			let parameter = {
				str:ids,
				uid:this.currUid
			}
			this.loading = true
			userRoleSave(parameter).then( res => {
				this.roleShow = false
					this.loading = false
				if(res.status == 1){
					this.$message.success('角色分配成功')
					this.getdata(this.formInline)
				}else{
					this.$message.error(res.msg)
				}
			})

		},





		//批量分配角色
		roleSaveList(){

			let parameter = {
				roleIds:this.checkRoles.join('-'),
				uids:this.currUids.join('-')
			}

			this.loading = true
			saveRoleIdBatch(parameter).then( res => {
				this.roleShow = false
				this.loading = false
				if(res.status == 1){

					this.$message.success('批量分配角色成功')
					this.getdata(this.formInline)
				}else{
					this.$message.error(res.msg)
				}
			})


		},


		//批量分配部门
		deptSaveList(){
			let parameter = {
				 userInfoIds:this.currUids.join('-'),
				 depId:this.deptId

			}
			this.loading = true

			setBtchDept(parameter).then(res => {
				this.loading = false
				this.deptShow = false
				if(res.status == 1){

					this.$message.success('批量分配部门成功')
					this.getdata(this.formInline)
				}else{

					this.$message.error(res.msg)
				}
			})
			.catch(err => {
				this.deptShow = false
				this.$message.error("数据请求错误！")
			})
		},



		//保存修改密码
		savePassword(){
			let parameter = {
				password:this.newPassword,
				uid:this.currUid,

			}
			passwordUpdate(parameter).then( res =>{
				this.passwordShow = false
				if(res.status == 1){
					this.$message.success('密码修改成功！')

				}
			})
		},



    // 选择复选框事件
    selectChange(val) {

      this.currUids = val.map( item => item.uid)

    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'role') {
        this.roleShow = false
      } else if (dialog == 'unit') {
        this.passwordShow = false
      } else if(dialog == 'dept'){
				this.deptShow = false
			}
    },
    // 删除用户
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 删除
          userDelete({uid:row.uid})
            .then(res => {
              if (res.status == 1) {
                this.$message({
                  type: 'success',
                  message: '数据已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('数据删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！'
          })
        })
    },
    // 重置密码
    resetpwd(index, row) {
      this.passwordShow=true
			this.currUid = row.uid
    },
    // 数据权限
    dataAccess: function(index, row) {
      this.roleShow = true
      this.saveroleId = row.userId
      UserDeptTree(row.userId)
        .then(res => {
          if (res.data.success) {
            this.checkmenu = this.changemenu(res.data.data)
            this.UserDept = this.changeArr(res.data.data)
          } else {
            this.$message({
              type: 'info',
              message: res.data.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('获取权限失败，请稍后再试！')
        })
    },


    // 菜单权限-保存
    menuPermSave() {
      let parm = {
        userId: this.saveroleId,
        deptIds: ''
      }
      let node = this.$refs.tree.getCheckedNodes()
      let moduleIds = []
      if (node.length != 0) {
        for (let i = 0; i < node.length; i++) {
          moduleIds.push(node[i].id)
        }
        parm.deptIds = JSON.stringify(moduleIds)
      }
      UserDeptSave(parm)
        .then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '权限保存成功'
            })
            this.roleShow = false
            this.getdata(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('权限保存失败，请稍后再试！')
        })
    },

    // 刷新缓存
    refreshCache(index, row) {
      userFlashCache(row.userName)
        .then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '刷新成功！'
            })
            this.getdata(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('刷新失败，请稍后再试！')
        })
    }
  }
}
</script>

<style scoped>

.userRole {
  width: 100%;
}
.tag {
	margin-right: 5px;
}
.el-checkbox{
	margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/user.vue